/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './FormButton.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeProps = {
  children: React.Node,
  isFlex: boolean,
} & TranslatorProps;

const FormButton: React.StatelessFunctionalComponent<*> = (props: TypeProps) => {
  const { children, isFlex, t }: TypeProps = props;
  const isFlexClass: string = isFlex ? styles['is-flex'] : '';

  return (
    <div className={`${styles['form-button']} ${isFlexClass}`}>
      <span>{t('general:or')}</span>
      {children}
    </div>
  );
};

export default translate()(observer(FormButton));
